import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=450177f2&scoped=true"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=450177f2&prod&scoped=true&lang=css&external"
import style1 from "./collections.vue?vue&type=style&index=1&id=450177f2&prod&scoped=true&lang=css"
import style2 from "./collections.vue?vue&type=style&index=2&id=450177f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450177f2",
  null
  
)

export default component.exports